import { CPaidPlanId } from '../../mdl/c-user';
import { FPageBlock } from '../../mdl/f-page-block';
import { UIButton } from '../../ui/component/button';
import { hLine } from '../../ui/component/line';
import { $el } from '../../ui/elements';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDBlockContainer } from '../editor';
import { fakeText } from '../elements';

function makePriceBox(plan: CPaidPlanId) {
    const button = new UIButton({ title: fakeText(12), kind: 'k-shadow' });

    return $el.DIV(['o-card m-shadow c-light ui-tint-blue'], [
        $el.DIV('r-symbol', [$el.DIV('sym sym-circle-ticket-1'), plan == 'plusone' && $el.DIV('sym sym-circle-ticket-1')]),
        $el.DIV('r-title', fakeText(5)),
        hLine('m-wide'),
        $el.DIV('r-price', fakeText(9)),
        $el.DIV('r-original', fakeText(6)),
        $el.UL([fakeText(10), fakeText(13), fakeText(9)]),
        button,
    ]);
}

export const ed_page_plans_block: EDBlockSpec<FPageBlock> = {
    key: 'plans',
    editor_block: class extends EDBlock {
        constructor(container: EDBlockContainer) {
            super($form({}), container, 'Subscription plans');
            this.classList.add('blk-plans', 'b', 'b-content', 'w-block');

            this.ui_add([
                makePriceBox('standard'),
                makePriceBox('plusone')
            ]);
        }
    },
};
